import type { TicketStatus } from '../../domain/support/guards';

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
    open: 'Aberto',
    in_progress: 'Em andamento',
    resolved: 'Resolvido',
    closed: 'Fechado',
};

export const TICKET_STATUS_OPTIONS = (Object.entries(TICKET_STATUS_LABELS) as [TicketStatus, string][]).map(
    ([value, label]) => ({ value, label })
);
